
define('ldsh!modules/address/item/template', [], function() {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<h1>Address</h1>\n<dl>\n  \n\t <dd>\n   <span name="work_phone"></span>\n  </dd>\n  \n\t <dd>\n   <span name="home_phone"></span>\n  </dd>\n  \n\t <dd>\n   <span name="mobile"></span>\n  </dd>\n  \n\t <dd>\n   <span name="fax"></span>\n  </dd>\n  \n\t <dd>\n   <span name="notes"></span>\n  </dd>\n  \n\t <dd>\n   <span name="street1"></span>\n  </dd>\n  \n\t <dd>\n   <span name="street2"></span>\n  </dd>\n  \n\t <dd>\n   <span name="city"></span>\n  </dd>\n  \n\t <dd>\n   <span name="state"></span>\n  </dd>\n  \n\t <dd>\n   <span name="pocode"></span>\n  </dd>\n\n</dl>';

}
return __p
};});

